var map = {
	"./brother.png": "120d",
	"./canon.png": "ffe7",
	"./epson.png": "0737",
	"./fujitsu.png": "8a86",
	"./hp.png": "206d",
	"./kmbs.png": "7ba9",
	"./kyocera.png": "e190",
	"./lexmark.png": "b0da",
	"./neopost.png": "0573",
	"./panasonic.png": "161b",
	"./samsung.png": "a13e",
	"./square-9.png": "22a7",
	"./xerox.png": "9801",
	"./zebra.png": "f051"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c47d";